const LocalConsts = {
    questionsId: "questionsId",
   
  };
  
  export const {
    questionsId,
    
  } = LocalConsts;